import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=690c7563&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QAvatar,QToolbarTitle,QSpace,QBtnDropdown,QList,QSeparator,QItem,QItemSection,QItemLabel,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QBtn,QAvatar,QToolbarTitle,QSpace,QBtnDropdown,QList,QSeparator,QItem,QItemSection,QItemLabel})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
